<template>
    <div class="secondary-menu create-event" v-if="event.visible" @click.self="closeEvent" tabindex="0">
        <div class="secondary-menu-header">
            <i class="back" @click="back()"></i>
            <div v-if="!spot_location" class="title">{{ head_title }}</div>
            <LocationDropdown  @setSpotLocation="setSpotLocation" :spots_lat="spot_lat ? spot_lat : profile.lat" :spots_lng="spot_lng ? spot_lng : profile.lng" :address_head="spot_address ? spot_address : profile.address" v-else ></LocationDropdown>
        </div>
        <vue-custom-scrollbar  ref="vueCustomScrollbar" :settings="scrollBarSettings" id="scroll-event" class="secondary-menu-body">
            <div class="tab-content-wrapper event-category-tabs"
                :class="{'friends': type === 'friends', 'fun': type === 'fun', 'bang': type === 'bang'}">
                <div class="tab-content-inner">
                    <div class="tab-content">
                        <EventCreate :spotLng="spot_lng" :spotLat="spot_lat" @typechoose="updateTypeChoosed" :key="eventCreateKey" v-bind:vars="$data" :aboutEvents="aboutEvents"/>
                    </div>
                </div>
            </div>
        </vue-custom-scrollbar>
    </div>
</template>

<script>
    import {mapGetters, mapState, mapActions} from 'vuex';
    import eventsModule from '@events/module/store/type'

    import EventCreate from "@events/views/widgets/event/create/EventCreate";

    // custom scrollbar
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"
    import LocationDropdown from "../../../../buddy/views/widgets/LocationDropdown.vue";

    export default {
        mixins: [
            require('@general/lib/mixin').default,
            require('@general/lib/mixin-events').default,
        ],
        data() {
           return {
             ...this.defaultData(),
             eventCreateKey: 0,
             address:false,
             spot_location:false,
             type_choosed: false,
             head_title: '',
             open_location_block: true,
             spot_lat: false,
             spot_lng: false,
             spot_address: ''
           }
        },
        components: {
          LocationDropdown,
          Map,
            EventCreate,
            vueCustomScrollbar
        },
        computed: {
            ...mapState({
              profile: 'profile'
            }),
            ...mapGetters({
                event: eventsModule.getters.event,
                publicPhotos: 'publicPhotos',
                publicVideos: 'publicVideos'
            }),
            aboutEvents() {
              return [
                  {
                    title: this.trans('events.type.fun'),
                    description: this.trans('events.about_fun'),
                    icon : 'date',
                    type: 'fun'
                  },
                  {
                    title: this.trans('events.type.bang'),
                    description: this.trans('events.about_bang'),
                    icon : 'chill',
                    type: 'bang'
                  },
                  {
                    title: this.trans('events.type.guide'),
                    description: this.trans('events.about_guide'),
                    icon : 'guide',
                    type: 'guide'
                  },
              ]
            },
            selectedPhotosArray() {
                let photosIds = this.publicPhotos.map(function (e) {
                    return e.id;
                }, []);

                return this.selectedPhotos = photosIds
            },
            selectedVideosArray() {
                let videoIds = this.publicVideos.map(function (e) {
                    return e.id;
                }, []);
                return this.selectedVideos = videoIds;
            }
        },
        mounted () {
          app.$on('show-scroll', this.showScroll);
        },
        methods: {
          setSpotLocation: function ({lat,lng, address}){
            this.spot_lat = lat;
            this.spot_lng = lng;
            this.spot_address = address;
          },
          updateTypeChoosed: function (payload) {
            this.type_choosed = payload.typechoose;
            this.head_title = payload.head_text;
            this.spot_location = payload.spot_location;
          },
          showScroll(slot) {
            this.scrollBarSettings.suppressScrollY = !slot;
          },
          back(){
            if(this.type_choosed){
              this.eventCreateKey++;
            }else{
              this.closeEvent();
            }
          },
          defaultData() {
            return {
                title: '',
                event_date: '', //this needs moment globally for vee-validate to work
                time: '',
                spot_location:false,
                description: ``,
                location: '',
                address_type: 'full_address',
                address: '',
                addressShow: '',
                addressError: false,
                tags: [],
                newTag: "",
                type: '',
                chemsfriendly: false,
                is_profile_linked: false,
                date: '',

                website: '',
                venue: '',
                name: '',
                contact: '',
                note: '',

                lat: 52.520389,
                lng: 13.40424,

                locality: 'Berlin',
                state: 'Berlin',
                country: 'Germany',
                country_code: 'DE',

                //inner components variables
                mapVisible: null,
                mapFirstTime: true,
                //selected photos for event
                selectedPhotos: [],
                selectedVideos: [],
                defaultEventPhoto: 'url("/assets/img/default_180x180.jpg") center / cover',
                deletedPhotos: [],
                deletedVideos: [],
                photos: [],

                //slim
                croppers: [],
                editPhotoId: null,
                slimOptions: this.defaultSlimOptions(),
                step4NextDisabled: true,
                preview_photo: [],
                textarea: {
                  rows: 1,
                  height: 45,
                  scrollHeight: null,
                  baseScrollHeight: 0,
                },
                customToolbar: [
                  ["bold", "italic", "underline"],
                  [{ list: "ordered" }, { list: "bullet" }]
                ],
                descriptionMaxLength: 3000,

                scrollBarSettings: {
                  suppressScrollY: false,
                  suppressScrollX: true
                },
            }
          }
        }
    }
</script>
